module.exports = __webpack_public_path__ + "img/web-map-jj.4d780a0b.jpg";